module.exports = __webpack_public_path__ + "media/images/gray_jean_light-e4a054e68f92bd3a81936f256d7c15db.png";